import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import DescriptionIcon from "@mui/icons-material/Description";
import StandardRequirementModal from "./StandardRequirementModal";

const StandardCard = ({
  standard,
  openAddRequirementModal,
  openDeleteModal,
}) => {
  const [showRequirementModal, setShowRequirementModal] = useState(false);

  return (
    <>
      <Card sx={{ mb: 1, borderRadius: "16px",boxShadow:"none", border:"1px solid #eee" }}>
        <CardHeader
          title={
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: "#eee",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <DescriptionIcon sx={{ color: "#0000a0" }} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mb: 1, fontSize: "14px" }}
                >
                  {standard.standard}
                </Typography>
                <Chip
                  label={`${standard.requirements.length} Requirements`}
                  size="small"
                  sx={{ bgcolor: "#dbeafe", color: "#1e40af" }}
                />
              </Box>
            </Box>
          }
          action={
            <Box sx={{ display: "flex", gap: 1, alignContent:"center",alignItems:"center",height:"100%" }}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => openAddRequirementModal(standard.standard)}
                sx={{
                  color: "#059669",
                  borderColor: "#d1fae5",
                  bgcolor: "#f0fdf4",
                  fontSize: "10px",
                  "&:hover": { bgcolor: "#dcfce7" },
                }}
              >
                Add Requirement
              </Button>
              <Button
                variant="outlined"
                startIcon={<DeleteIcon />}
                onClick={() => openDeleteModal(standard.standard)}
                sx={{
                  color: "#dc2626",
                  borderColor: "#fecaca",
                  bgcolor: "#fef2f2",
                  fontSize: "10px",
                  "&:hover": { bgcolor: "#fee2e2" },
                }}
              >
                Delete
              </Button>
              <Button
                onClick={() => setShowRequirementModal(true)}
                sx={{
                  fontSize: "10px",
                  color: "#0000a0",
                  border: "1px solid #0000a0",
                  borderRadius: "4px",
                  padding: "6px 12px",
                }}
              >
                View Requirements
              </Button>
            </Box>
          }
        />
      </Card>

      {showRequirementModal && (
        <StandardRequirementModal
          title={standard.standard}
          requirements={standard.requirements}
          onClose={() => setShowRequirementModal(false)}
          handleSave={() => {
            setShowRequirementModal(false); // You can update this later
          }}
          loading={false}
        />
      )}
    </>
  );
};

export default StandardCard;
